module.exports = __webpack_public_path__ + "static/media/ee.aa81d134.svg";